import React, {
  PropTypes,
} from 'react'

import { TextEllipsis } from '../styled'

import coinPic from '../assets/coin_ver2_02.png'

function compare (a, b) {
  if (a.coin < b.coin) {
    return -1
  }
  if (a.coin > b.coin) {
    return 1
  }
  return 0
}
const _cardExamProduct = ({
                        imgURL,
                        productName,
                        coin: coinPriceDate,
                        numQuestion,
                        rating,
                        userrating,
                        href,
                        myLibExam,
                        isInMylib,
                      }) => (
                        <li className="product">
                          <div className="picture">
                            <a href={href} className="cws-right fancy cws-slide-left ">
                              <img src={imgURL} data-at2x={imgURL} alt="" />
                            </a>
                          </div>
                          <div className="product-name custom-product-name-test">
                            <a href={href}><TextEllipsis>{productName}</TextEllipsis></a>
                          </div>
                          <div style={{ lineHeight: '20px' }}>
                            <span>จำนวนคำถาม : {numQuestion}</span>
                          </div>
                          <div className="star-rating" title={`Rated ${rating} out of 5`} style={{ display: 'inline-flex' }}>
                            <span style={{ width: `${rating * 20}%` }} /><div style={{ display: 'inline', marginTop: '-2px', fontSize: '12px' }}>({userrating})</div>
                          </div>
                          <span className="price">
                            <span className="amount">
                              {/* <div style={{ color: '#3fc29d', marginTop: '5px', marginLeft: '10px', display: 'table' }}><img src={coinPic} alt="" style={{ width: '15px', display: 'table-cell', marginRight: '5px' }} /> <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>{coinPriceDate.length !== 0 ? `${coinPriceDate.sort(this.compare)[0].coin} ~ ${coinPriceDate.sort(this.compare)[coinPriceDate.length - 1].coin}` : '' }</div></div> */}
                              {/* {coinPriceDate.length !== 0 && coinPriceDate[0].coin !== null && (typeof coinPriceDate[0].coin !== 'undefined') ?
                                <span>
                                  <img src={coinPic} alt="" style={{ width: '12px', display: 'inline-block', marginRight: '5px', marginTop: '2px' }} /> {`${coinPriceDate.sort(compare)[0].coin} ~ ${coinPriceDate.sort(compare)[coinPriceDate.length - 1].coin}`}
                                </span>
                                : ''
                              } */}
                              {
                                isInMylib === true ?
                                <span>
                                  เริ่มสอบ
                                </span> : ''
                              }
                              { coinPriceDate.length > 1 && isInMylib !== true?
                                <span>
                                  {`${coinPriceDate.sort(compare)[0].coin} ~ ${coinPriceDate.sort(compare)[coinPriceDate.length - 1].coin}`} บาท
                                </span> : ''
                              }
                              { coinPriceDate[0].coin === 0 && coinPriceDate.length === 1 && isInMylib !== true?
                                <span>
                                  ฟรี
                                </span> : ''
                              }
                              { coinPriceDate.length === 1 && coinPriceDate[0].coin !== 0 && isInMylib !== true?
                                <span>
                                  {`${coinPriceDate[0].coin}`} บาท
                                </span> : ''
                              }
                              {/* <span>
                                <img src={coinPic} alt="" style={{ width: '12px', display: 'inline-block', marginRight: '5px', marginTop: '2px' }} /> ฟรี
                              </span> */}
                            </span>
                          </span>
                        </li>
                      )

_cardExamProduct.propTypes = {
  imgURL: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  coin: PropTypes.number.isRequired,
  numQuestion: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  userrating: PropTypes.number.isRequired,
  href: PropTypes.string.isRequired,
  myLibExam: PropTypes.object.isRequired,
  isInMylib: PropTypes.bool,
}

export default _cardExamProduct



// WEBPACK FOOTER //
// ./src/components/cardExamProduct.js